import Header from "../components/header.jsx";
import Sidebar from "../components/sidebar.jsx";
import PaidCustomer from "../components/paidcustomer.jsx";
import Footer from "../components/footer.jsx";

function PaidCustomerpage() {
    return (
        <div>
        <div className='wrapper'>
          <Header />
          <Sidebar /> 
          <PaidCustomer /> 
        </div>
        <Footer /> 
      </div>
      // <Login/>
      );
}
export default PaidCustomerpage;
